import React from 'react';

import { FormGroup, ControlLabel } from 'react-bootstrap';

import { BookingOption } from '../../../../../../../types/Activity';
import RadioButtons from '../../../../../../utils/FormWidgets/RadioButtons';
import SimpleSelect from '../../../../../../utils/FormWidgets/SimpleSelect';

type RadioButtonProps = {
  label: string;
  name: keyof BookingOption;
  onChange(key: keyof BookingOption, value: boolean): void;
  value?: boolean;
  options?: { label: string; value: boolean }[];
  disabled?: boolean;
};

type SimpleSelectProps = {
  label: string;
  onChange(value: unknown): void;
  value?: string;
  options?: { label: string; value: string }[];
  disabled?: boolean;
};

const SelectBookingOptionField = ({
  label,
  onChange,
  value,
  options,
  disabled = false,
}: SimpleSelectProps) => {
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <SimpleSelect
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        disabled={disabled}
        onChange={onChange}
        value={value}
        data={options}
      />
    </FormGroup>
  );
};

const RadioBookingOptionField = ({
  label,
  name,
  value,
  options,
  onChange,
  disabled = false,
}: RadioButtonProps) => {
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <RadioButtons
        name={name}
        value={value || false}
        onRadioChange={() => onChange(name, !value)}
        options={options}
        disabled={disabled}
      />
    </FormGroup>
  );
};

export { SelectBookingOptionField, RadioBookingOptionField };
